import { useState } from 'react';
import {
  CheckMarkStyled,
  VideoThumbnailContainerStyled,
} from './video-thumbnail-viewer.styled';
import VideoThumbnail from 'react-video-thumbnail';
import { CheckIcon } from '@heroicons/react/24/outline';
import { IconSize } from '@constants';
import { useTheme } from '@mui/material';
interface Props {
  videoUrl: string;

  selectedThumbnailUrl?: string;
  snapshotAtTime: number;
  thumbnailHandler?: (thumbnail: string) => void;
  onSelect: (thumbnail: string | undefined) => void;
}

export const VideoThumbnailViewer = ({
  videoUrl,
  selectedThumbnailUrl,
  snapshotAtTime,

  onSelect,
}: Props) => {
  const [generatedThumbnail, setGeneratedThumbnail] = useState<
    string | undefined
  >();
  const theme = useTheme();
  const isSelected = generatedThumbnail === selectedThumbnailUrl;

  return (
    <VideoThumbnailContainerStyled
      onClick={() => onSelect(generatedThumbnail)}
      selected={isSelected}
    >
      <VideoThumbnail
        snapshotAtTime={snapshotAtTime}
        videoUrl={videoUrl}
        thumbnailHandler={(thumbnail: string) => {
          setGeneratedThumbnail(thumbnail);
        }}
      />
      {isSelected && (
        <CheckMarkStyled>
          <CheckIcon height={IconSize.sm} color={theme.palette.white.main} />
        </CheckMarkStyled>
      )}
    </VideoThumbnailContainerStyled>
  );
};
